import React, { useEffect, useRef } from "react";
import "./PartnerWithUs.scss";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";

export default function PartnerWithUs() {
  const sectionRefs = useRef([]);

  useEffect(() => {
    document.title = "Partner With Us | Celbion Healthcare";
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    sectionRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const addRef = (el) => {
    if (el && !sectionRefs.current.includes(el)) sectionRefs.current.push(el);
  };

  return (
    <>
      <div className="pw-root">
        <BannerSectionStyle3
          bgUrl="/images/about/banner_bg.jpg"
          imgUrl="/images/about/banner_img.png"
          title="Partner With Us"
        />

        {/* ── BUSINESS DEVELOPMENT ── */}
        <section className="pw-biz">
          <div className="pw-biz-inner fade-in" ref={addRef}>
            <div>
              <div className="pw-section-tag">Business Development</div>
              <h2 className="pw-section-title">
                Collaboration at the<br /><em>Heart of Growth</em>
              </h2>
              <p className="pw-body-text">
                At Celbion Healthcare, collaboration drives every initiative. We actively
                partner with organizations that share our vision of delivering high-quality,
                evidence-based healthcare solutions—especially in managing complex and chronic conditions.
              </p>
              <p className="pw-body-text">
                We build strong alliances with trusted manufacturers who uphold the highest standards
                in quality and innovation, enabling us to bring reliable medicines to patients and
                healthcare providers across markets.
              </p>
              <p className="pw-body-text">
                Our structured, execution-driven approach ensures operational excellence at every level—
                creating sustainable, long-term value for our stakeholders, partners, and the
                communities we serve.
              </p>
            </div>
            <div className="pw-biz-right">
              <div className="pw-stat-card">
                <div className="pw-stat-num">01</div>
                <div className="pw-stat-label">Quality-First Manufacturing Alliances</div>
              </div>
              <div className="pw-stat-card">
                <div className="pw-stat-num">02</div>
                <div className="pw-stat-label">Evidence-Based Healthcare Solutions</div>
              </div>
              <div className="pw-stat-card">
                <div className="pw-stat-num">03</div>
                <div className="pw-stat-label">Sustainable Long-Term Stakeholder Value</div>
              </div>
              <div className="pw-stat-card">
                <div className="pw-stat-num">04</div>
                <div className="pw-stat-label">Accessible & Affordable Medicines</div>
              </div>
            </div>
          </div>
        </section>

        {/* ── PARTNER WITH US ── */}
        <section className="pw-partner">
          <div className="pw-partner-inner fade-in" ref={addRef}>
            <div className="pw-section-tag" style={{ justifyContent: "center" }}>Partner With Us</div>
            <h2 className="pw-section-title">
              Built on <em>Trust,</em><br />Driven by Shared Success
            </h2>
            <p className="pw-partner-body">
              At Celbion Healthcare, we believe that strong partnerships are built on trust,
              transparency, and shared success. We maintain ethical and long-lasting relationships
              with our partners—working closely together to achieve mutual growth while making a
              meaningful impact in healthcare.
            </p>
            <p className="pw-partner-body">
              We are continuously looking for partners who align with our core principles:
            </p>

            <div className="pw-values-grid">
              {[
                "Vision for better healthcare",
                "Commitment to quality",
                "Strong ethical values",
                "Patient-first approach",
              ].map((val) => (
                <div className="pw-value-item" key={val}>
                  <div className="pw-value-dot" />
                  <span className="pw-value-text">{val}</span>
                </div>
              ))}
            </div>

            <p className="pw-closing">
              "Together, we can make quality healthcare more accessible
              and improve lives without limits."
            </p>
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="pw-cta">
          <div className="pw-cta-box fade-in" ref={addRef}>
            <h2 className="pw-cta-title">Get in Touch</h2>
            <p className="pw-cta-sub">Explore Partnership Opportunities</p>
            <a
              className="pw-cta-email"
              href="mailto:info@celbionhealthcare.com"
            >
              <span>📧</span>
              info@celbionhealthcare.com
            </a>
          </div>
        </section>
      </div>
    </>
  );
}
